import React from "react";

const Referrals = () => (
  <div className="container">
    <h1>Referrals</h1>
  </div>
);

export default Referrals;
